React = require 'react/addons'
AgeProtectedRoute = require '../mixins/age-protected-route'
LightMode = require '../mixins/light-mode'
VideoPlayer = require './shared/video-player'
NavigationActions = require '../actions/navigation'

module.exports = React.createClass
  displayName: 'Film'

  mixins: [AgeProtectedRoute, LightMode]

  componentDidMount: ->
    NavigationActions.hideNavigation()
  componentWillUnmount: ->
    NavigationActions.showNavigation()

  render: ->
    video =
      key: 'main-video',
      name:'santera',
      thumb:"/img/screenshots/SanteraDoc_1080_H264_Subs.jpg",
      mp4:"/videos/film-20150224.mp4",
      webm:"/videos/film-20150224.webm"

    React.createElement(VideoPlayer, {"key": (video.key), "video": (video), "embed": '<iframe src="//player.vimeo.com/video/118599844?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> <p><a href="http://vimeo.com/118599844">Santera / Brand Film</a> from <a href="http://vimeo.com/exposureamerica">exposure</a> on <a href="https://vimeo.com">Vimeo</a>.</p>'})



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/film.cjsx
 **/